const CDN_BASE_URL = document?.documentElement?.dataset?.cdnBaseUrl;

export const publicAssetPath = fileName => {
  return [CDN_BASE_URL, fileName].join("");
};
